import React from 'react'
import SiteHeader from './SiteHeader'
import NavMenu from './NavMenu'


export default function LayoutContainer({global, dispatch, location, children}) {


  return (
    <div
      style={{
        padding: '3rem 0rem 0rem 0rem',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'stretch',
      }}
    >

      <SiteHeader
        global={global}
        dispatch={dispatch}
        location={location}
      />

      <NavMenu
        global={global}
        dispatch={dispatch}
        location={location}
      />

      <div
        style={{
          flex: '1 1 auto',
          position: 'relative',
          margin: '3em',
          zIndex: '1',
        }}
      >
        {children}
      </div>

    </div>
  )
}
